<div role="main" class="mdc-main-content" id="content">
  <app-header></app-header>
  <div class="iw-breadcrumb">
    <span class="iw-breadcrumb-node">
      <a href="https://www.miamidade.gov/global/home.page">Home</a></span>
    <span class="iw-breadcrumb-separator">&nbsp;>&nbsp;</span>
    <span class="iw-breadcrumb-node">
      <a href="https://www.miamidade.gov/global/animals/home.page">Animal Services</a></span>
    <span class="iw-breadcrumb-separator">&nbsp;>&nbsp;</span>
    <span class="iw-breadcrumb-node">Animal Outcome Viewer</span>
  </div>
  <div class="container">
    <div class="row">
      <h1 class="mdc-page-title">Animal Outcome Viewer</h1>
      <div class="row col l8 s12 m8" style="padding-left: 10px;">
        <app-outcomemessage></app-outcomemessage>
      </div>
      <div class="class=row col l8 s12 m8"style="padding-left: 10px;">
        <app-animaloutcome></app-animaloutcome>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
<router-outlet></router-outlet>